/**
 * Marks an error as already handled (e.g. toast already shown by the API interceptor).
 * Use isHandledError() in catch blocks to skip duplicate notifications.
 */
export function markHandled(err: Error): Error {
  (err as Error & { alreadyHandled: boolean }).alreadyHandled = true;
  return err;
}

export function isHandledError(err: unknown): boolean {
  return (
    err instanceof Error &&
    (err as Error & { alreadyHandled?: boolean }).alreadyHandled === true
  );
}
